import { MaxBrainWidget } from '../models/widget.model';

export class AddWidgets {
    static readonly type = '[Audience] AddWidgets';

    constructor(public payload: MaxBrainWidget[]) {}
}
